/* eslint-disable no-param-reassign */
import produce from 'immer';

const initialState = {
  message: '',
  variant: ''
};

const toasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@toaster-event': {
      const { message, variant } = action.payload;

      return produce(state, draft => {
        draft.message = message;
        draft.variant = variant;
      });
    }

    default: {
      return state;
    }
  }
};

export default toasterReducer;
